import { COMMA, ENTER, SPACE } from '@angular/cdk/keycodes';
import {
  AfterViewInit, Component, EventEmitter, Input, OnInit, Output
} from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatChipInputEvent } from '@angular/material/chips';
import { TokenService } from 'viggo-sistemas-core-web';
import { TagsService } from '../../../tags/services/tags.service';

@Component({
  selector: 'chip-input',
  templateUrl: 'chip-input.component.html',
  providers: [TagsService]
})
export class ChipInputComponent implements OnInit, AfterViewInit {
  /**
   * Valor inicial a ser setado
   */
  @Input('initialValue')
  public initialValue: any;
  /**
   * Exibe apenas uma tag
   */
  @Input('showOnlyOne')
  public showOnlyOne: boolean = false;

  @Input('readonly')
  public readonly: boolean = false;

  /**
   * Flag responsável por refatorar exibição das tags para contato
   */
  @Input('tagContato')
  public tagContato: boolean = false;

  @Input('placeholder') placeholder = 'Tag ...';

  @Input('color') color;
  /**
   * Emite o evento toda vez que é inserido ou removido
   * uma tag no form
   */
  @Output() public onChange = new EventEmitter<string[]>();

  /**
   * Formulário onde as informações são inscritas
   */
  public form: UntypedFormGroup;
  /**
   * Atalho para o form de tag
   */
  public formTag: UntypedFormArray;
  /**
   * Teclas que separam as tags quando clicadas no input
   */
  @Input()
  public teclasSeparadoras = [ENTER, COMMA, SPACE];
  @Input()
  public isTagSystem = false;

  public constructor(
    private fb: UntypedFormBuilder,
    protected tagsService: TagsService,
    protected tokenService: TokenService
  ) {}

  /**
   * Faz o update da form de tags
   * @param tags lista com novos valores
   */
  public setListaTags(tags: string[]): ChipInputComponent {
    this.formTag.reset();
    tags
      .map(tag => this.fb.control(tag))
      .forEach(tagControl => this.formTag.push(tagControl));

    return this;
  }

  public ngOnInit(): ChipInputComponent {
    // Primeiro ele verifica se o componente está trabalhando com contato
    if (this.tagContato) {
      var tagsCtt = typeof this.initialValue === 'string' ? this.initialValue.split(' ') : this.initialValue;
      //se a primeira posição não for vazia ele busca as tags do resolver
      this.form = this.fb.group({
        tag: this.fb.array(tagsCtt[0] !== '' && typeof tagsCtt[0] === 'object'? tagsCtt.map(t => this.fb.control(t)) : [])
      });
      // caso a posição não seja vazia e em formato string ele busca na entidade tag
      if(typeof tagsCtt[0] === 'string' && tagsCtt[0] !== '') this.reloadTags(tagsCtt);
    } else {
      const tags = this.transformValue();

      this.form = this.fb.group({
        tag: this.fb.array(tags.map(t => this.fb.control(t)))
      });
    }
    this.formTag = this.form.controls.tag as UntypedFormArray;

    return this;
  }
  /**
   * Transforma o valor repassado em um array de string
   */
  private transformValue(): string[] {
    var { initialValue } = this;
    initialValue = initialValue === undefined ? '' : initialValue;
    let tags: string[];
    if (!initialValue.length) tags = [];
    else
      tags =
        typeof initialValue === 'string'
          ? initialValue.split(' ')
          : initialValue;
    return tags;
  }

  public ngAfterViewInit(): void {
    this.formTag.valueChanges.subscribe(value => this.emitirValores(value));
  }

  /**
   * Busca as tags de contato
   * @param tags
   */
  reloadTags(tags) {
    if(this.tagContato){
      tags.forEach(t => {
        this.formTag = this.form.controls.tag as UntypedFormArray;
        if(t !== '')
          this.formTag.push(this.fb.control({ value: t, color: 'gray' }));
      })
    }else{
      tags.forEach(t => {
        this.tagsService
          .getEntitiesByParams(
            `&page=${0}&page_size=${10}&list_options=ACTIVE_ONLY&tag_name=${t}`,
            this.tokenService.getDomain().id,
            true
          )
          .subscribe(tag => {
            if (tag.data.length === 0) {
              this.formTag.push(this.fb.control({ value: '#'+t+' ', color: 'gray' }));
            } else {
              this.formTag.push(
                this.fb.control({
                  value: tag.data[0].tag_name,
                  color: tag.data[0].color
                })
              );
            }
          });
      });
    }
  }

  /**
   *  Adiciona uma nova tag
   * @param event evento repassado
   */
  public addNovaTag(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    // caso não haja informação função é interrompida
    if (!value) return;
    const tempTags: Array<any> = this.formTag.value;
    if(tempTags.find(t => t.value === value) || value.includes('#')) return;
    if (!tempTags.includes(value) && !this.isTagSystem) {
      this.tagsService
        .getEntitiesByParams(
          `&page=${0}&page_size=${10}&list_options=ACTIVE_ONLY&tag_name=${value}`,
          this.tokenService.getDomain().id,
          true
        )
        .subscribe(tag => {
          if (tag.data.length === 0) {
            tempTags.push(value);
            this.formTag.push(this.fb.control({ value: '#'+value+' ', color: 'gray' }));
          } else {
            tempTags.push(tag.data[0]);
            this.formTag.push(
              this.fb.control({
                value: tag.data[0].tag_name,
                color: tag.data[0].color
              })
            );
          }
        });
    }else{
      this.formTag.push(this.fb.control({ value: '#'+value+' ', color: 'gray' }));
    }
    event.input.value = '';
  }

  /**
   * Remove uma tag do form
   * @param tag valor a ser removido
   */
  public removerTag(tag: UntypedFormControl): ChipInputComponent {
    const index = this.formTag.value.findIndex((v: string) => v === tag.value);
    if (index >= 0) this.formTag.removeAt(index);

    return this;
  }

  /**
   * emite as mudancas feitas
   * @param value valor a ser emitido
   */
  private emitirValores(value: string[]): void {
    this.onChange.emit(value);
  }
}
